
import displayCurrency from '@/globals/filters/currency'
import displayDate from '@/globals/filters/date'

const displayCreditRange = (value) => {
  switch (value) {
    case 'Excellent': return '>720'
    case 'Good': return '680-719'
    case 'Fair': return '640-679'
    case 'Poor': return '<639'
    default: return 'Not provided'
  }
}

const displayLoanType = (value) => {
  switch (value) {
    case 'SBA': return 'SBA Loan'
    case 'Conv': return 'Conventional Loan'
    default: return 'Undecided / No Preference'
  }
}

export default (value, key) => {
  if (key === 'createdAt') value = displayDate(value)
  if (key === 'dealSize') value = displayCurrency(value)
  if (key === 'creditScore') value = displayCreditRange(value)
  if (key === 'loanType') value = displayLoanType(value)

  if (typeof value === 'boolean') {
    value = value ? 'Yes' : 'No'
  }

  if (Array.isArray(value)) {
    value = value.length ? value.join(', ') : 'None Selected'
  }

  if (value === null) {
    value = 'Undecided / No Preference'
  }

  if (!value) {
    value = 'N/A or Not Provided'
  }

  return value
}
